import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQuery } from 'shared/api/baseQuery';

import { UpdateIssueDto } from './dto/update-issue.dto';
import { IssueFiltersResponse, IssuesAPIResponse } from './types';

export const issuesApi = createApi({
  reducerPath: 'issues',
  baseQuery,
  tagTypes: ['Issues'],
  endpoints: builder => {
    return {
      getIssues: builder.query<IssuesAPIResponse, Record<string, unknown>>({
        query: queryParams => {
          return {
            url: '/api/issues',
            params: queryParams,
          };
        },
        transformResponse: (response: IssuesAPIResponse): IssuesAPIResponse => {
          return response;
        },
        providesTags: ['Issues'],
      }),
      deleteIssue: builder.mutation<void, number>({
        query: id => {
          return {
            method: 'DELETE',
            url: `/api/issues/${id}`,
          };
        },
        invalidatesTags: ['Issues'],
      }),
      deleteIssueBulk: builder.mutation<void, Array<number>>({
        query: ids => {
          return {
            method: 'DELETE',
            url: `/api/issues/bulk`,
            body: ids,
          };
        },
        invalidatesTags: ['Issues'],
      }),
      updateIssuesBulk: builder.mutation<void, UpdateIssueDto>({
        query: data => {
          return {
            method: 'PATCH',
            url: '/api/issues/bulk',
            body: data,
          };
        },
        invalidatesTags: ['Issues'],
      }),
      getIssueFilters: builder.query<IssueFiltersResponse, void>({
        query: () => `/api/issues/filters`,
      }),
    };
  },
});

export const {
  useGetIssuesQuery,
  useDeleteIssueMutation,
  useDeleteIssueBulkMutation,
  useUpdateIssuesBulkMutation,
  useGetIssueFiltersQuery,
} = issuesApi;
